import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  sigla: '',
  estado: '',
  pais: [],
  codigo_ibge: '',
  icms_interno: '',
};

export const UFContext = createContext();

export const UFProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [uf, setUF] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getUF = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: uf?.filter,
        page: uf?.page,
        size: uf?.size,
        order: uf?.order,
        ...payload,
      });
      setUF((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <UFContext.Provider
      value={{
        getLoading,
        uf,
        getUF,
      }}
    >
      {children}
    </UFContext.Provider>
  );
};
